<template>
  <div :data-intro="dataIntro">
    <router-link :to="urlPath">
      <Button size="lg">
        New
        <vue-feather type="plus-circle" size="20" />
      </Button>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { Button } from '@/components/ui/button';
import type { ContactRecordType } from '@/api/entity_types/Contact';

const { contactType } = defineProps<{
  contactType: ContactRecordType;
}>();

const urlPath = computed<string>(() => {
  return contactType === 'Teammate' ? '/team/new' : '/contacts/new';
});

const dataIntro = computed(() => {
  return contactType === 'Teammate'
    ? 'Use this button to add an individual agent to your team.'
    : 'Use this button to add a new candidate.';
});
</script>
